import { render, staticRenderFns } from "./YgUserDetail.vue?vue&type=template&id=47649d75&scoped=true"
import script from "./YgUserDetail.vue?vue&type=script&lang=js"
export * from "./YgUserDetail.vue?vue&type=script&lang=js"
import style0 from "./YgUserDetail.vue?vue&type=style&index=0&id=47649d75&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47649d75",
  null
  
)

export default component.exports